<template>
  <div id="page">
    <b-container class="header full-width">
      <b-row no-gutters>
        <b-col cols="2" class="centering"><back-button /></b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="2"></b-col>
        <b-col cols="8"><h1>{{this.recipe['name']}}</h1></b-col>
      </b-row>
    </b-container>
    
    <b-embed
      type="iframe"
      aspect="16by9"
      :src = this.recipe.video
      allowfullscreen
      class="video"
    ></b-embed>
    <p class="m-0"> Video Source: {{this.recipe["video-source"]}}</p>
    <p> Recipe Source: {{this.recipe["recipe-source"]}}</p>
    <p>Time: {{this.recipe['time']}} mins</p>
    <h3>Ingredients:</h3>
    <ul class="list">
      <li v-for="(details, ingredient) in this.recipe['ingredients']" :key=ingredient>
        {{ingredient}} – {{details['value']}} {{details['units']}}
      </li>
    </ul>
    <h3>Steps:</h3>
    <ol>
      <li class="mb-2 list-item" v-for="step in this.recipe['steps']" :key=step>
        {{step}}
      </li>
    </ol>
  </div>
</template>

<script>
import BackButton from '../components/backButton.vue';
import recipe_data_json from "../data/recipe-data.json";

export default {
  name: "Recipe",
  components: {
    BackButton
  },
  props: {
    recipeName: String
  },
  data: function () {
    return {
      recipe: recipe_data_json.recipe_data_raw[this.$route.params.recipeName]
    }
  }
}
</script>
<style scoped>
h1{
  margin:0px;
}

#page{
  padding-bottom: 100px;
}

.centering{
  display: flex;
  justify-content: left;
}
.video{
  width: 100%; 
  height: 55vw;
}
.list{
  width: 80%; 
  margin-left: 10%; 
  text-align: left;
}

.list-item{
  text-align: left;
}

ol {
  margin-bottom: 20px;
}
</style>